import toast from "react-hot-toast";
import { CreateProjectModalForm, CreateProjectModalResponse, UseCreateProjectHook } from "../types";
import { MasterAccountProjectType } from "../../../../types/MasterAccountProjectType";
import { useCreateProjectMutation } from "../../../../services/clientprojects";

export const useCreateProject = (masterAccountId: string) : UseCreateProjectHook => {
    const [mutate, { isLoading }] = useCreateProjectMutation();
    
    const onCreateHandler = (form: CreateProjectModalForm) : Promise<CreateProjectModalResponse> => new Promise<CreateProjectModalResponse>((resolve) => {
        return toast.promise<MasterAccountProjectType>(mutate({ masterAccountId, data: form }).unwrap(), {
            loading: 'Creating new Project...',
            success: 'Project was created successfully',
            error: 'Failed to create Project.'
        }).then(
            (v: MasterAccountProjectType) => resolve({ status: 201, message: '', project: v }),
            () => resolve({ status: 400, message: 'Failed to create project', project: null })
        )
    });

    return { 
        create: onCreateHandler,
        isLoading
    };
};